/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Edit_PermissionsInputs */

const vi_api_keys_edit_permissions = /** @type {(inputs: Api_Keys_Edit_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa quyền`)
};

/**

* @param {Api_Keys_Edit_PermissionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_edit_permissions = /** @type {((inputs?: Api_Keys_Edit_PermissionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Edit_PermissionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_edit_permissions(inputs)
});